/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */

import {
  DOCUMENT_SCAN,
  FACE_VERIFICATION,
  RESERVATION_LIST_FORM,
  SEARCH_RESERVATION,
} from "../../routes/Paths";
import {
  getConfigurationCode,
  getParametersFromLocalStorage,
  getStepMaster,
  homePageHandler,
  getProfileName,
  getScanDataFullName,
  formatDate,
} from "../../helpers/commonHelper";
import {
  addItem,
  getDocumentListTypes,
  getDocumentTypes,
  getScanBackData,
  getScanData,
  getScanDocResult,
  getScanDocumentCurrentCountOfGuest,
  resetDocReponse,
  resetReponse,
  resetSannedDocumentDetails,
  scannedDocumentDetails,
  setDocumentInfo,
  validateScanDocument,
} from "../../store/Checkin/Scan/documentScanSlice";
import {
  fetchReservation,
  getProfilesListData,
  getReservationData,
  resetIsFinished,
  setModuleType,
} from "../../store/Checkin/reservationformSlice";
import { userReservationDetailsPassport } from "../../store/Checkin/Scan/scanPassportSlice";
import {
  fetchStep,
  postAuditLog,
  postStageDetails,
} from "../../store/stageSlice";
import {
  getAllowedDocuments,
  getScanDataFromWebhost,
  getScanDataFromWebhostBack,
} from "../../network/apiService";
import { CONFIG_MASTER_ENUM, STEP_MASTER_ENUM } from "../../constants/constant";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import DocumentVerification from "../../components/UserVerification/DocumentVerification";
import ErrorPopup from "../../components/LoaderAndNotification/ErrorPopup";
import FlipDocumentModal from "../../components/Layout/Card/FlipDocumentModal";
import Footer from "../../components/Layout/Footer";
import HomePageCard from "../../components/Layout/Card/HomePageCard";
import LoaderPopup from "../../components/LoaderAndNotification/LoaderPopup";
import React from "react";
import SuccessPopup from "../../components/LoaderAndNotification/SuccessPopup";
import { TitleCaseConverter } from "../../components/Plugins/TitleCaseCoverter";
import { getModuleConfiguration } from "../../store/Checkin/moduleConfigurationSlice";
import { getPropertyInfo } from "../../store/Checkin/Scan/propertySlice";
import { getSelectedLanguage } from "../../store/Checkin/languageSlice";
import i18n from "i18next";
import { timerConstantValue } from "../../constants/timers";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";
import useUserActivity from "../../hooks/useUserActivity";
import { Modal } from "@mui/material";
import Calendar from "react-calendar";
// import { updateReservationData } from "../../store/Checkin/reservationformSlice";

const PassportScanning = () => {
  const { t } = useTranslation();
  const selectedLanguage = useSelector(getSelectedLanguage);

  const timeLimit = timerConstantValue;
  const [showModal, setShowModal] = useState(false);
  const [scanData, setScanData] = useState();
  const [flipDocument, setFlipDocument] = useState(false);
  const [flipModalToggle, setFlipModalToggle] = useState(false);
  const dispatch = useDispatch();

  const [userData, setUserData] = useState({});
  const [active, setActive] = useState("");
  const [loading, setLoading] = useState(false);
  const [timerValue, setTimerValue] = useState(timeLimit);
  const [restartTimer, setRestartTimer] = useState(false);
  const [successLoader, setSuccessLoader] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [scannedLastName, setScannedLastName] = useState(false);
  const calendarRef = useRef(null);
  const [erroModalData, setErrorModalData] = useState({
    toggleError: false,
    errorMessage: "",
  });
  const [transactionGUID, setTransactionGUID] = useState("");
  const navigate = useNavigate();
  const token = getParametersFromLocalStorage("token");
  const [show, setShow] = useState(true);
  //const [childCount, setChildCount] = useState(0);
  const guestCount = useSelector(getScanDocumentCurrentCountOfGuest);
  const propertyData = useSelector(getPropertyInfo);
  const reservationData = useSelector(getReservationData);
  const profileList = useSelector(getProfilesListData);
  const scanDocResult = useSelector(getScanDocResult);
  const totalCount = parseInt(localStorage.getItem("totalCount") || 0);
  const childCount = parseInt(localStorage.getItem("childCount") || 0);
  // const totalGuestCount = parseInt(localStorage.getItem("totalGuestCount") || 0);
  // const confirmAdultChildCount = parseInt(localStorage.getItem("confirmAdultChildCount"));
  const { type } = useParams();
  const documentTypes = useSelector(getDocumentTypes);
  const documentTypesList = useSelector(getDocumentListTypes);

  const stepMaster = useSelector((state) => getModuleConfiguration(state));
  const [lastName, setLastName] = useState("");
  const [isPrimaryGuest, setIsPrimaryGuest] = useState(false);
  const scanFrontData = useSelector(getScanData);
  const scanBackData = useSelector(getScanBackData);
  const [isChildProfile, setIsChildProfile] = useState(true);
  const [selectedDate, setSelectedDate] = useState(null);
  const [minDate, setMinDate] = useState("");

  const settings = getParametersFromLocalStorage("settings");
  const calendarType = settings?.find(
    (setting) => setting.parameterName === "CalendarType"
  );
  const childAgeLimit = settings?.find(
    (setting) => setting.parameterName === "ChildAgeLimit"
  )?.parameterValue;
  const adultAgeLimit = settings?.find(
    (setting) => setting.parameterName === "AdultAgeLimit"
  )?.parameterValue;
  const enableChildScan = settings?.find(
    (setting) =>
      setting.parameterName === "EnableChildScan" &&
      setting.parameterValue?.toLowerCase() === "true"
  );
  const enableAdultScan = settings?.find(
    (setting) =>
      setting.parameterName === "EnableAdultScan" &&
      setting.parameterValue?.toLowerCase() === "true"
  );
  const documentScanPage =
    stepMaster && stepMaster.length > 0
      ? stepMaster.find((ele) => ele.stepCode === "SKI03")
      : null;

  const [showDocumentScanPage, setDocumentScanPage] = useState(
    documentScanPage?.isEnabled ? true : false
  );
  const stepReservationPage = getStepMaster(
    stepMaster,
    STEP_MASTER_ENUM.HOME_PAGE
  );
  const configs = stepReservationPage?.configs;
  const adultChildCountChangeRequired =
    getConfigurationCode(
      configs,
      CONFIG_MASTER_ENUM.CHILDCOUNT_CHANGE_REQUIRED
    ) ?? false;

  const documentScanConfigs = documentScanPage?.configs;
  const skipFullDocumentValidation =
    getConfigurationCode(
      documentScanConfigs,
      CONFIG_MASTER_ENUM.SKIP_FULL_DOCUMENT_VALIDATION
    ) ?? false;

  const calendarValidation = settings?.find(
    (setting) => setting.parameterName === "calendarValidation"
  );

  //calender validation
  useEffect(() => {
    if (
      calendarValidation !== null &&
      calendarValidation !== undefined &&
      calendarValidation?.parameterValue === "true"
    ) {
      setMinDate(new Date());
    } else {
      setMinDate(void 0);
    }
  }, []);

  //KC-447 Timer need to restart when user interaction is involved
  useUserActivity(() => {
    setTimerValue(timeLimit);
  });

  useEffect(() => {
    dispatch(resetSannedDocumentDetails());
    const isChild = isChildOrAdult();

    setIsChildProfile(isChild);
    console.log("documentScanConfigs: ", documentScanConfigs);
    console.log("skipFullDocumentValidation: ", skipFullDocumentValidation);

    //verifyStageInface();
  }, []);

  useEffect(async () => {
    i18n.changeLanguage(selectedLanguage);

    if (
      profileList !== null &&
      profileList !== undefined &&
      profileList !== null &&
      profileList?.length > guestCount
    ) {
      // const fullName =
      //   (profileList[guestCount].title !== "null" &&
      //   profileList[guestCount].title?.length > 0
      //     ? profileList[guestCount].title + "."
      //     : "") +
      //   ((profileList[guestCount].firstName?.length > 0
      //     ? nameValidation(profileList[guestCount].firstName + " ")
      //     : "") +
      //     (profileList[guestCount].lastName?.length > 0
      //       ? nameValidation(profileList[guestCount].lastName)
      //       : ""));
      setLastName(getProfileName(null, null, profileList[guestCount]));
    }

    if (guestCount === 0) {
      setIsPrimaryGuest(true);
    }
    if (type !== undefined) setModuleType(type);
    try {
      if (!showDocumentScanPage) {
        navigate(FACE_VERIFICATION, { replace: true });
        return;
      }
    } catch (error) {
    } finally {
      clearTimeout(timeoutId);
    }
  }, []);

  useEffect(async () => {
    if (token !== null && token !== undefined && documentTypes === null) {
      const docTypes = await getAllowedDocuments(
        {
          appType: "kiosk",
        },
        token
      );

      if (docTypes?.data?.result) {
        dispatch(setDocumentInfo(docTypes?.data?.data));
      }
    }
  }, [token]);

  const resetTimerAndClosePopUp = () => {
    if (!timerValue) {
      setTimerValue(timeLimit);
    }
    setRestartTimer(true);
    setShowModal(false);
  };

  useEffect(() => {
    // Set a 5 seconds delay
    const timer = setTimeout(() => {
      // Set the button visibility to true
      setShow(true);
    }, 5000);

    // Clear the timer when the component unmounts
    return () => clearTimeout(timer);
  }, []); // Pass an empty array to run the effect only once

  const timerCounter = (value) => {
    setTimerValue(value);
  };

  const openModal = () => {
    setShowModal(true);
  };

  const stopTimer = () => {
    setRestartTimer(false);
  };

  const closeErrorModal = () => {
    setErrorModalData((state) => ({
      ...state,
      toggleError: false,
      errorMessage: "",
    }));
  };
  const setCloseFlipModel = () => {
    setFlipModalToggle(false);
  };

  const isChildOrAdult = () => {
    //const isFaceMatched = scanData?.isFaceMatch ?? false;
    if (enableChildScan) {
      if (adultChildCountChangeRequired) {
        if (childCount > 0 && guestCount >= totalCount - childCount) {
          return true;
        }

        return false;
      } else {
        if (
          reservationData?.childCount > 0 &&
          guestCount >= reservationData?.adultCount
        ) {
          return true;
        }
        return false;
      }
    }

    // if (enableChildScan) {
    //   if (
    //     reservationData?.childCount > 0 &&
    //     guestCount >= reservationData?.adultCount
    //   ) {
    //     return true;
    //   }
    //   return false;
    // }
  };
  useEffect(() => {
    if (scanDocResult === true) {
      gotoNextScreen();
    }
  }, [scanDocResult]);

  // const verifyStageInface = async () => {

  //   if (profileList !== null && profileList !== undefined && userData) {
  //     let currentProfile = null;
  //     if ((profileList?.length ?? 0) > guestCount)
  //       currentProfile = profileList[guestCount];
  //     const confirmationNo = localStorage.getItem("confirmationNo");
  //     await dispatch(
  //       fetchStep({
  //         confirmationNo: confirmationNo,
  //         propertyCode: propertyData?.data?.propertyCode,
  //         type: "checkin",
  //         token: token,
  //         stepCode: "SEI02",
  //         profile: currentProfile,
  //         guestCount: guestCount,
  //       })
  //     )
  //       .unwrap()
  //       .then(async (isSkipped) => {
  //         gotoNextScreen(isSkipped);
  //       });
  //   }
  // };

  const gotoNextScreen = (isSkipped) => {
    dispatch(resetDocReponse());
    setSuccessLoader(false);
    if (type === "scan") {
      // navigate(`${RESERVATION_LIST_FORM}`, { replace: true });
      navigate(RESERVATION_LIST_FORM, { replace: true });
      //navigate(SEARCH_RESERVATION, { replace: true });
    } else {
      const isFaceMatched = scanData?.isFaceMatch ?? false;
      if (
        isFaceMatched === false &&
        (isSkipped === undefined || isSkipped === null || isSkipped === true)
      ) {
        setTimeout(() => {
          // navigate(`${FACE_VERIFICATION}`, { replace: true });
          navigate(FACE_VERIFICATION, { replace: true });
          return;
        }, 2000);
      } else {
        // navigate(`${DOCUMENT_SCAN}`, { replace: true });
        navigate(DOCUMENT_SCAN, { replace: true });
      }
    }
  };

  const addScanData = (data, backsidedata) => {
    if (type === "scan") {
      // if (backdata !== null && backdata !== undefined) {
      //   dispatch(
      //     scannedDocumentDetails({ scanData: data, scanBackData: backdata })
      //   );
      // } else if (data !== null && data !== undefined)
      //   dispatch(scannedDocumentDetails({ scanData: data }));
    } else {
      let currentProfile = null;
      if (
        profileList !== null &&
        profileList !== undefined &&
        profileList?.length > guestCount
      ) {
        currentProfile = profileList[guestCount];
      }
      if (backsidedata !== null && backsidedata !== undefined) {
        let backdata = { ...backsidedata };

        let frontdata = { ...scanFrontData };

        let names = scanFrontData?.FullName?.split(" ");
        if (
          scanFrontData?.GivenName?.split(" ").length >
            scanFrontData?.FullName?.split(" ").length &&
          scanFrontData?.GivenName !== frontdata.FullName
        ) {
          names = scanFrontData?.GivenName?.split(" ");
        } else {
          names = scanFrontData?.FullName?.split(" ");
        }
        if (scanFrontData) {
          frontdata.FirstName =
            scanFrontData?.GivenName ||
            scanFrontData?.FirstName ||
            names[names.length - 1];
          //frontdata.MiddleName = scanFrontData?.MiddleName || names[1];
          frontdata.LastName =
            scanFrontData?.FamilyName || scanFrontData?.LastName || names[0];
        }
        if (backsidedata) {
          let bnames = backdata?.FullName?.split(" ");
          if (
            backdata?.GivenName?.split(" ").length >
              backdata?.FullName?.split(" ").length &&
            backdata?.GivenName !== frontdata.FullName
          ) {
            bnames = backdata?.GivenName?.split(" ");
          } else {
            bnames = backdata?.FullName?.split(" ");
          }

          backdata.FirstName =
            frontdata.FirstName ||
            backdata.GivenName ||
            backdata.FirstName ||
            bnames[bnames.length - 1] ||
            "";

          // backdata.MiddleName = frontdata.MiddleName || backdata.MiddleName
          // || bnames[1] || "";

          backdata.LastName =
            frontdata.LastName ||
            backdata.FamilyName ||
            backdata.LastName ||
            bnames[0] ||
            "";

          frontdata.FirstName = backdata.FirstName;
          // frontdata.MiddleName = backdata.MiddleName;
          frontdata.LastName = backdata.LastName;
        }

        dispatch(
          addItem({
            scanData: frontdata,
            scanBackData: backdata,
            profile: currentProfile,
            reservation: reservationData,
          })
        );
      } else if (data !== null && data !== undefined) {
        let frontdata = { ...data };

        let names = [];
        if (
          frontdata.GivenName?.split(" ").length >
            frontdata.FullName?.split(" ").length &&
          frontdata.GivenName !== frontdata.FullName
        ) {
          names = frontdata?.GivenName?.split(" ");
        } else {
          names = frontdata?.FullName?.split(" ");
        }

        if (frontdata) {
          if ((frontdata?.FirstName ?? "") === "") {
            frontdata.FirstName =
              data?.FirstName ||
              data?.GivenName ||
              (Array.isArray(names) && names[names.length - 1]) ||
              "";
          }

          // if ((frontdata?.MiddleName ?? "") === "") {
          //   frontdata.MiddleName =
          //     data?.MiddleName || (Array.isArray(names) && names[1]) || "";
          // }

          if ((frontdata?.LastName ?? "") === "") {
            frontdata.LastName =
              data?.LastName ||
              data?.FamilyName ||
              (Array.isArray(names) && names[0]) ||
              "";
          }
        }

        dispatch(
          addItem({
            scanData: frontdata,
            profile: currentProfile,
            reservation: reservationData,
          })
        );
      }
    }
  };

  const fetchReservationCompleted = (
    reservationList,
    scanData,
    scanBackData
  ) => {
    if (
      reservationList !== null &&
      reservationList !== undefined &&
      reservationList?.result === true
    ) {
      dispatch(resetIsFinished());
      if (
        reservationList !== null &&
        reservationList !== undefined &&
        reservationList?.data !== null &&
        Array.isArray(reservationList?.data) &&
        reservationList.data.length > 0 &&
        type === "scan"
      ) {
        setFlipDocument(false);
        setFlipModalToggle(false);
        gotoNextScreen();
        addStageDeatils(true, "Success", "");
        // if (scanBackData !== null && scanBackData !== undefined) {
        //   // dispatch(
        //   //   scannedDocumentDetails({
        //   //     scanData: scanData,
        //   //     scanBackData: scanBackData,
        //   //   })
        //   // );
        // } else if (scanData !== null && scanData !== undefined)
        //   dispatch(scannedDocumentDetails({ scanData: scanData }));
        // setLoading(false);
      } else if (
        reservationList !== null &&
        reservationList !== undefined &&
        reservationList?.data !== null &&
        !Array.isArray(reservationList?.data) &&
        type === "scan"
      ) {
        userReservationDetailsPassport(reservationList);
        gotoNextScreen();
      } else {
        setLoading(false);
        setErrorModalData((state) => ({
          ...state,
          toggleError: true,
          errorMessage: t("No reservation details found"),
        }));
      }
    } else {
      if (
        reservationList?.error !== undefined &&
        reservationList?.error !== null &&
        reservationList?.error !== ""
      ) {
        setLoading(false);
        setSuccessLoader(false);
        setErrorModalData((state) => ({
          ...state,
          toggleError: true,
          errorMessage: reservationList?.error,
        }));
      } else if (
        reservationList?.data?.message !== undefined &&
        reservationList?.data?.message !== null &&
        reservationList?.data?.message !== ""
      ) {
        setLoading(false);
        setSuccessLoader(false);
        setErrorModalData((state) => ({
          ...state,
          toggleError: true,
          errorMessage: reservationList?.data?.message,
        }));
      } else {
        setLoading(false);
        setErrorModalData((state) => ({
          ...state,
          toggleError: true,
          errorMessage: t("No reservation details found"),
        }));
      }
    }
  };

  const scanCompleted = async (response, scanData, scanBackData) => {
    if (response?.isFinished === true && response?.result === true) {
      dispatch(
        scannedDocumentDetails({
          scanData: scanData,
          scanBackData: scanBackData,
        })
      );

      if (
        response?.isFlip === true &&
        (scanBackData === null || scanBackData === undefined)
      ) {
        setLoading(false);
        setFlipDocument(true);
        setFlipModalToggle(true);
        dispatch(resetReponse());
      } else {
        if (type === "scan") {
          let LastName = "";
          if (
            scanBackData !== null &&
            scanBackData !== undefined &&
            scanBackData.LastName !== null &&
            scanBackData.LastName !== undefined &&
            scanBackData.LastName !== ""
          ) {
            LastName = scanBackData.LastName;
          } else if (
            LastName === "" &&
            scanData !== null &&
            scanData !== undefined &&
            scanData.LastName !== null &&
            scanData.LastName !== undefined &&
            scanData.LastName !== ""
          ) {
            LastName = scanData.LastName;
          } else if (
            LastName === "" &&
            scanFrontData !== null &&
            scanFrontData !== undefined &&
            scanFrontData.LastName !== null &&
            scanFrontData.LastName !== undefined &&
            scanFrontData.LastName !== ""
          ) {
            LastName = scanFrontData.LastName;
          }
          setScannedLastName(LastName);
          setLoading(false);
          setShowCalendar(true);
          return;
        } else {
          let currentProfile = null;
          if (
            profileList !== null &&
            profileList !== undefined &&
            profileList?.length > guestCount
          ) {
            currentProfile = profileList[guestCount];
          }

          const scannedFullName = getScanDataFullName(scanData, scanBackData);
          //  addLog(
          //    scanBackData.DocumentImageSide1 ,
          //    (scanBackData?.Result),
          //    "validateScanDocument"
          //  );

          await dispatch(
            validateScanDocument({
              scanData:
                scanBackData === undefined || scanBackData === null
                  ? scanData
                  : scanBackData,
              profile: currentProfile,
              isChild: isChildProfile,
              adultAgeLimit,
              childAgeLimit,
              fullName: scannedFullName,
              skipFullDocumentValidation: skipFullDocumentValidation,
            })
          )
            .unwrap()
            .then((response) => {
              const isSuccess =
                response?.isFinished === true && response?.result === true;
              addStageDeatils(
                isSuccess,
                isSuccess ? "Success" : "",
                isSuccess ? "" : response?.error ?? "Scan Failed"
              );
              addScanData(scanData, scanBackData);
            });
        }
        dispatch(resetReponse());
      }
    } else {
      addStageDeatils(
        false,
        "",
        response?.error ? response?.error : "Scan Failed"
      );
      dispatch(resetReponse());
      setLoading(false);
      setSuccessLoader(false);
      setFlipModalToggle(false); //To close the flip modal upon error message
      setErrorModalData((state) => ({
        ...state,
        toggleError: true,
        errorMessage: response?.error,
      }));
    }
  };

  const resultsRef = React.useRef(scanData);
  resultsRef.current = scanData;

  useEffect(() => {
    if (userData.LastName && userData.CheckOutDate) {
      setActive("active");
    } else {
      setActive("");
    }
  }, [userData.CheckOutDate, userData.LastName]);

  const timeoutId = setTimeout(() => {
    if (!resultsRef.current) {
      return;
    }
  }, 30000);

  //Backside
  const completedScanDone = async () => {
    try {
      setLoading(true);
      const scanDataBack = await Promise.race([
        getScanDataFromWebhostBack(guestCount),
        wait(30000),
      ]);
        var scanDataBackLog = {...scanDataBack?.data, DocumentImageSide1: "ImageData", Portrait: "portrait image"};
        addLog(
          JSON.stringify(scanDataBackLog),
          scanDataBack?.data?.Result,
          "Scanned Back Side Data"
        );

      if (scanDataBack.data !== null && scanDataBack.data?.Result === true) {
        //scanDataBack.data.transactionGUID = transactionGUID;
        const updatedScanData = {
          ...scanDataBack.data,
          //DocumentImageSide1: scanDataBack.data?.DocumentImageSide2,
          transactionGUID: transactionGUID,
        };

        if (
          (scanData.Portrait === null || scanData.Portrait === "") &&
          (scanDataBack.data.Portrait === null ||
            scanDataBack.data.Portrait === "")
        ) {
          addStageDeatils(
            false,
            "",
            "Invalid face image detected. Please scan front side of document again."
          );
          setErrorModalData((state) => ({
            ...state,
            toggleError: true,
            errorMessage: t(
              "Invalid face image detected. Please scan front side of document again."
            ),
          }));
          setLoading(false);

          setSuccessLoader(false);

          return;
        }

        if (
          (scanData.DocumentNumber === null ||
            scanData.DocumentNumber === undefined ||
            scanData.DocumentNumber === "") &&
          (scanData.DocumentType === null ||
            scanData.DocumentType === undefined ||
            scanData.DocumentType === "") &&
          (scanDataBack.data.DocumentNumber === null ||
            scanDataBack.data.DocumentNumber === undefined ||
            scanDataBack.data.DocumentNumber === "") &&
          (scanDataBack.data.DocumentType === null ||
            scanDataBack.data.DocumentType === undefined ||
            scanDataBack.data.DocumentType === "")
        ) {
          addStageDeatils(false, "", scanData.data?.Message);
          setErrorModalData((state) => ({
            ...state,
            toggleError: true,
            errorMessage: t(
              "No document detected. Please place a valid document on the scanner for verification."
            ),
          }));
          setFlipDocument(false);
          setFlipModalToggle(false);
          setLoading(false);
          setSuccessLoader(false);

          return;
        }

        setFlipDocument(false);

        //const currentProfile = profileList[guestCount];
        const currentProfile = profileList?.[guestCount] ?? null;
        const scannedFullName = getScanDataFullName(updatedScanData, scanData);

        dispatch(
          validateScanDocument({
            scanData: updatedScanData,
            profile: currentProfile,
            isChild: isChildProfile,
            adultAgeLimit,
            childAgeLimit,
            isBackSide: true,
            fullName: scannedFullName,
            skipFullDocumentValidation: skipFullDocumentValidation,
          })
        )
          .unwrap()
          .then((response) => {
            scanCompleted(response, null, updatedScanData);
          });
      } else {
        addStageDeatils(false, "", scanData.data?.Message);
        setErrorModalData((state) => ({
          ...state,
          toggleError: true,
          errorMessage: t(
            "No document detected. Please place a valid document on the scanner for verification."
          ),
        }));
        setFlipDocument(false);
        setFlipModalToggle(false);
        setLoading(false);
        setSuccessLoader(false);

        return;
      }
    } catch (error) {
      addLog(
        JSON.stringify({
          message: error.message,
          name: error.name,
          code: error.code,
          stack: error.stack,
          method: error?.config?.method,
          url: error?.config?.baseURL + error?.config?.url,
          responseData: error?.response?.data,
        }),
        null,
        "Exception in completedScanDone: Error while scanning"
      );
      setErrorModalData((state) => ({
        ...state,
        toggleError: true,
        errorMessage: error.message,
      }));
      setLoading(false);
      setFlipDocument(false);
      setFlipModalToggle(false);
      setSuccessLoader(false);
      return;
    }
  };
  // const addLog = (response, request, message) => {
  //   const confirmationNo = localStorage.getItem("confirmationNo");
  //   const data = {
  //     ActionName: "Scan",
  //     Message: message,
  //     ControllerName: "kiosk",
  //     Request: request ?? "",
  //     PMSConfirmationNo: confirmationNo,
  //     AppType: "kiosk",
  //     Response: response ?? "",

  //     PropertyCode: propertyData?.data?.propertyCode,
  //   };
  //   dispatch(postAuditLog({ data, token }));
  // };

  const addLog = (response, request, message) => {
    const confirmationNo = localStorage.getItem("confirmationNo");

    const isError = response instanceof Error;

    const structuredResponse = isError
      ? {
          name: response.name,
          message: response.message,
          code: response.code,
          stack: response.stack,
          url: response?.config?.baseURL + response?.config?.url,
          method: response?.config?.method,
          headers: response?.config?.headers,
          responseData: response?.response?.data,
        }
      : response;

    const data = {
      ActionName: "Scan",
      Message: message,
      ControllerName: "kiosk",
      Request: request ?? "",
      PMSConfirmationNo: confirmationNo,
      AppType: "kiosk",
      Response:
        typeof structuredResponse === "string"
          ? structuredResponse
          : JSON.stringify(structuredResponse, null, 2),
      PropertyCode: propertyData?.data?.propertyCode,
    };

    dispatch(postAuditLog({ data, token }));
  };

  const addStageDeatils = (IsSuccess, SuccessMessage, FailureReason) => {
    const confirmationNo = localStorage.getItem("confirmationNo");
    const propertyCode = localStorage.getItem("propertyCode");
    const data = {
      PMSConfirmationNo: confirmationNo,
      IsSuccess: IsSuccess,
      StepCode: "SKI03",
      SubStep: "DocumentUpload",
      AppType: "kiosk",
      SuccessMessage: SuccessMessage ?? "",
      FailureReason: FailureReason ?? "",
      PropertyCode: propertyCode,
    };

    if (confirmationNo === null || confirmationNo === undefined) return;
    dispatch(postStageDetails({ data, token }));
  };

  const wait = (milliseconds) =>
    new Promise((res, rej) =>
      setTimeout(
        () =>
          rej(
            new Error(`Request timed out after ${milliseconds / 1000} seconds`)
          ),
        milliseconds
      )
    );

  const scanDocument = async () => {
    try {
      setLoading(true);
      let scanData;
      let childAge;

      // scanData = await Promise.race([
      //   //document scanning entry point
      //   getScanDataFromWebhost(guestCount),
      //   wait(60000),
      // ]);
      try {
        scanData = await Promise.race([
          getScanDataFromWebhost(guestCount),
          wait(60000),
        ]);
        var scanDataLog = {...scanData?.data, DocumentImageSide1: "ImageData", Portrait: "portrait image"};
        addLog(
          JSON.stringify(scanDataLog),
          scanData?.data?.Result,
          "Scanned Front Side Data"
        );
        if (
          scanData.data.DocumentNumber !== null &&
          scanData.data.DocumentNumber !== undefined &&
          scanData.data.DocumentNumber !== "" &&
          (scanData.data.DocumentType === null ||
            scanData.data.DocumentType === undefined ||
            scanData.data.DocumentType === "")
        ) {
          scanData.data.DocumentType = "ID";
        }
      } catch (error) {
        // Log the failure BEFORE continuing
        addLog(
          JSON.stringify({
            message: error.message,
            name: error.name,
            code: error.code,
            stack: error.stack,
            method: error?.config?.method,
            url: error?.config?.baseURL + error?.config?.url,
            responseData: error?.response?.data,
          }),
          null,
          "getScanDataFromWebhost : Error while scanning document through webhost"
        );
      }

      // addLog(
      //   JSON.stringify(scanData.data),
      //   scanData.data?.Result,
      //   "Front Scan Of Guest"
      // );
      if (scanData.data != null && scanData.data?.Result === true) {
        const uniqueId = uuidv4();
        setTransactionGUID(uniqueId);
        if (!skipFullDocumentValidation) {
          if (enableChildScan) {
            if (
              isChildOrAdult() &&
              scanData?.data?.Age !== undefined &&
              scanData?.data?.Age !== "" &&
              parseInt(scanData?.data?.Age) > parseInt(childAgeLimit)
            ) {
              setLoading(false);
              setSuccessLoader(false);
              addStageDeatils(
                false,
                "",
                "Invalid document. Child age can not be greater than" +
                  childAgeLimit
              );
              setErrorModalData((state) => ({
                ...state,
                toggleError: true,
                errorMessage:
                  t("Invalid document. Child age can not be greater than ") +
                  childAgeLimit,
              }));
              return;
            }
          }
          if (
            (enableChildScan === null || enableChildScan === undefined) &&
            scanData?.data?.Age !== undefined &&
            scanData?.data?.Age !== "" &&
            parseInt(scanData?.data?.Age) < parseInt(adultAgeLimit)
          ) {
            setLoading(false);
            setSuccessLoader(false);
            addStageDeatils(
              false,
              "",
              "Invalid document. Adult should be greater than" + adultAgeLimit
            );
            setErrorModalData((state) => ({
              ...state,
              toggleError: true,
              errorMessage:
                t("Invalid document. Adult should be greater than") +
                adultAgeLimit,
            }));
            return;
          }

          if (
            isChildProfile &&
            scanData?.data?.Age !== undefined &&
            scanData?.data?.Age !== "" &&
            parseInt(scanData?.data?.Age) > parseInt(childAgeLimit)
          ) {
            setLoading(false);
            setSuccessLoader(false);
            addStageDeatils(
              false,
              "",
              "Invalid document. Child age can not be greater than" + childAge
            );
            setErrorModalData((state) => ({
              ...state,
              toggleError: true,
              errorMessage:
                t("Invalid document. Child age can not be greater than") +
                childAge,
            }));
            return;
          }
          if (
            scanData?.data?.LastName === "" &&
            scanData?.data?.GivenName === "" &&
            (scanData?.data?.Portrait === "" ||
              scanData?.data?.Portrait === null ||
              scanData?.data?.Portrait === undefined)
          ) {
            setLoading(false);
            setSuccessLoader(false);
            addStageDeatils(
              false,
              "",
              "Invalid document. Please scan back side of the document."
            );
            setErrorModalData((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t(
                "Invalid document. Please scan back side of the document."
              ),
            }));
            return;
          }
        }

        if (
          skipFullDocumentValidation &&
          (scanData.data?.Portrait === null ||
            scanData.data?.Portrait === undefined ||
            scanData.data?.Portrait === "")
        ) {
          setLoading(false);
          setSuccessLoader(false);
          addStageDeatils(
            false,
            "",
            "Invalid document. Face Portrait is missing in the document."
          );
          setErrorModalData((state) => ({
            ...state,
            toggleError: true,
            errorMessage: t(
              "Invalid document. Face Portrait is missing in the document."
            ),
          }));
          return;
        }

        if (
          scanData?.data?.LastName === "" &&
          scanData?.data?.GivenName !== "" &&
          scanData?.data?.GivenName !== undefined &&
          scanData?.data?.GivenName !== null
        ) {
          scanData.data.LastName = scanData?.data?.GivenName;
        }

        const updatedScanData = {
          ...scanData.data,
          transactionGUID: uniqueId, // Modify the transactionGUID property
        };

        setScanData(updatedScanData);
        const scannedFullName = getScanDataFullName(updatedScanData, null);

        if (profileList !== null && profileList?.length > guestCount) {
          const currentProfile = profileList[guestCount];
          console.log("-----------------------");
          await dispatch(
            validateScanDocument({
              scanData: updatedScanData,
              profile: currentProfile,
              isChild: isChildProfile,
              adultAgeLimit,
              childAgeLimit,
              fullName: scannedFullName,
              skipFullDocumentValidation: skipFullDocumentValidation,
            })
          )
            .unwrap()
            .then((response) => {
              scanCompleted(response, updatedScanData, null);
            });
          console.log("-----------------------");
        } else {
          await dispatch(
            validateScanDocument({
              scanData: updatedScanData,
              isChild: isChildProfile,
              adultAgeLimit,
              childAgeLimit,
              fullName: scannedFullName,
              skipFullDocumentValidation: skipFullDocumentValidation,
            })
          )
            .unwrap()
            .then((response) => {
              scanCompleted(response, updatedScanData, null);
            });
        }
      } else {
        // addLog(JSON.stringify(scanData.data), scanData.data?.Result, "");
        addStageDeatils(
          false,
          "",
          "No document detected. Please place a valid document on the scanner for verification."
        );
        setLoading(false);
        setSuccessLoader(false);
        setErrorModalData((state) => ({
          ...state,
          toggleError: true,
          errorMessage: t(
            "No document detected. Please place a valid document on the scanner for verification."
          ),
        }));
        return;
      }
    } catch (error) {
      // addLog(error, false, "Error in scanning");
      addLog(
        JSON.stringify({
          message: error.message,
          name: error.name,
          code: error.code,
          stack: error.stack,
          method: error?.config?.method,
          url: error?.config?.baseURL + error?.config?.url,
          responseData: error?.response?.data,
        }),
        null,
        "Exception in scanDocument: Error while scanning"
      );
      addStageDeatils(false, "", "Error in scanning document");
      setErrorModalData((state) => ({
        ...state,
        toggleError: true,
        errorMessage: t("Error while scanning document"),
      }));
      setLoading(false);
      setSuccessLoader(false);
      return;
    } finally {
      clearTimeout(timeoutId);
    }
    return;
  };
  const handlebackPage = () => {
    try {
      homePageHandler(dispatch, navigate);
    } catch (error) {
      console.error("Error capturing image:", error);
    }
  };

  const handleDateChange = async (date) => {
    setSelectedDate(date);
    setShowCalendar(false);
    setLoading(true);
    const fullDate = formatDate(date);
    await dispatch(
      fetchReservation({
        lastName: scannedLastName,
        checkOutDate: fullDate,
        propertyCode: propertyData?.data?.propertyCode,
        token: token,
      })
    )
      .then((response) => {
        if (response?.payload ?? null !== null) {
          //const givenName = scanData?.GivenName?.toLowerCase();

          // const givenName = (scanData?.GivenName?.trim()
          //         ? scanData.GivenName.toLowerCase()
          //         : scanData?.FirstName?.toLowerCase()) || "";

          //  if(givenName==null)
          //  {

          //     setErrorModalData((state) => ({
          //     ...state,
          //     toggleError: true,
          //     errorMessage: t("Failed to get response"),
          //   }));

          //     setLoading(false);
          //  }
          //  // Keep full payload structure but filter only the `data`
          // const filteredResponse = {
          //   ...response.payload,
          //   data: response.payload.data.filter(
          //     (item) => item.firstName?.toLowerCase() === givenName.toLowerCase()
          //   ),
          // };
          //  dispatch(updateReservationData(filteredResponse));
          fetchReservationCompleted(response.payload, scanData, scanBackData);
          // fetchReservationCompleted(filteredResponse, scanData, scanBackData);
        } else {
          setErrorModalData((state) => ({
            ...state,
            toggleError: true,
            errorMessage: t("Failed to get response"),
          }));

          setLoading(false);
        }
      })
      .catch((error) => {
        // Handle the error here, e.g., log it or display an error message.
        setErrorModalData((state) => ({
          ...state,
          toggleError: true,
          errorMessage: error.error,
        }));
        setLoading(false); // Set loading to false in case of an error.
      });
    //document.getElementsByName("selectedDate")[0].value = fullDate;
  };

  const weekFormats = (date, culture, localizer) => {
    // weekdayFormat: (date, culture, localizer) => localizer.format(date, 'dddd', culture),
    localizer.format(date, "dddd", culture);
  };

  const pad = (number) => {
    return number < 10 ? "0" + number : number;
  };

  const formatDate1 = (date) => {
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const year = date.getFullYear();
    return year + "-" + month + "-" + day + "T00:00:00";
  };

  return (
    <div>
      <main>
        <LoaderPopup loading={loading} />
        <ErrorPopup
          closeErrorModal={closeErrorModal}
          erroModalData={erroModalData}
        />

        <SuccessPopup
          loading={successLoader}
          successMessage={t("Document scanning completed successfully")}
        />
        <FlipDocumentModal
          completedScanDone={completedScanDone}
          flipModalToggle={flipModalToggle}
          closeModel={setCloseFlipModel}
        />

        {documentTypesList !== null && documentTypesList?.length > 0 && (
          <>
            <DocumentVerification
              loading={loading}
              successLoader={successLoader}
              successMessage={t("Document scanning completed successfully")}
              openModal={openModal}
              closeErrorModal={closeErrorModal}
              erroModalData={erroModalData}
              userData={userData}
              scanDocumentHandler={scanDocument}
              completedScanDone={completedScanDone}
              flipModalToggle={flipModalToggle}
              guestCount={guestCount}
              totalCount={totalCount}
              show={show}
              currentProfile={
                profileList !== undefined &&
                profileList !== null &&
                guestCount >= 0
                  ? profileList[guestCount]
                  : null
              }
              documentTypes={documentTypesList}
              onBackPressed={handlebackPage}
              lastName={lastName}
              isPrimaryGuest={isPrimaryGuest}
              closeModel={setCloseFlipModel}
              isChild={isChildProfile}
              childCount={childCount}
            />
          </>
        )}

        <Footer
          page={"documentscanning"}
          showModal={showModal}
          openModal={openModal}
          timerCounter={timerCounter}
          timerValue={timerValue}
          restartTimer={restartTimer}
          stopTimer={stopTimer}
          timeLimit={timeLimit}
        />
      </main>
      {showModal && (
        <HomePageCard
          showModal={showModal}
          resetTimerAndClosePopUp={resetTimerAndClosePopUp}
        />
      )}
      {showCalendar && (
        <Modal
          open={showCalendar}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: "1",
          }}
        >
          <div className="calendar-popup" ref={calendarRef}>
            <button
              id="btn-checkincheckouttoggle-closecalendar"
              className="close-icon"
              onClick={() => setShowCalendar(false)}
            >
              {t("X")}
            </button>
            <div className="calendar-header">
              <h5 className="calendar-title">
                {" "}
                {t("Choose Your")} {t("Checkout Date")?.toLowerCase()}{" "}
              </h5>
            </div>
            <Calendar
              onChange={handleDateChange}
              value={formatDate(selectedDate)}
              // tileDisabled={({ date }) => {
              //   const today = new Date();
              //   // Allow interaction with visible next month dates
              //   return date < today;
              // }}
              tileDisabled={() => false}
              locale={selectedLanguage}
              formatLongDate={(locale, date) =>
                formatDate1(date, "dd MMM YYYY")
              }
              minDate={minDate}
              format={weekFormats}
              //calendarType="iso8601"
              calendarType={calendarType?.parameterValue ?? "iso8601"}
            />
          </div>
        </Modal>
      )}
    </div>
  );
};

export default PassportScanning;
